import { Alert, Snackbar } from "@mui/material";

import { useAppDispatch, useAppSelector } from "@/store";
import { closeSnackbar } from "@/store/slices/snackbarSlice";
import { Z_INDEX } from "@/constants/zIndex";

/**
 * One host for `state.snackbar`, mounted beside the drawer and modal hosts.
 *
 * The original raises every transient message through a single slice, so there
 * is exactly one snackbar on screen at a time and each caller supplies its own
 * severity and anchor. Reproduced here the same way.
 */
export default function SnackbarHost() {
  const dispatch = useAppDispatch();
  const { open, message, severity, anchorOrigin, autoHideDuration } =
    useAppSelector((state) => state.snackbar);

  return (
    <Snackbar
      open={open}
      message={undefined}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      onClose={() => dispatch(closeSnackbar())}
      sx={{ zIndex: Z_INDEX.TOAST }}
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={() => dispatch(closeSnackbar())}
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
